import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController, PopoverController, AlertController, Events, LoadingController, Platform } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { PatronProvider } from '../../providers/patron/patron';
import { CoGuestRegisterInputComponent } from '../../components/co-guest-register-input/co-guest-register-input';
import { CoEventRegisterCustomQuestionComponent } from '../../components/co-event-register-custom-question/co-event-register-custom-question';
import { EventsProvider } from '../../providers/events/events';
import { AppState } from '../../config/state';
import { CoPopoverKeyboardComponent } from '../../components/co-popover-keyboard/co-popover-keyboard';

import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { LoginProvider } from '../../providers/login/login';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { CoSelfcheckAccountPage } from '../co-selfcheck-account/co-selfcheck-account';

/**
 * Generated class for the CoEventsRegisterModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-events-register-modal',
  templateUrl: 'co-events-register-modal.html',
})
export class CoEventsRegisterModalPage {
  headerTitle: string = "Event Registration";
  event: any;
  searchTags: any;
  clientKeyword: any;
  requireLogin: boolean;
  allowGuests: boolean;
  guestList: Array<any> = [];
  eventAges: any;
  showAges: boolean;
  clientSettings: any;
  emailRegex: any;
  phoneRegex: any;
  viewType: any;
  loggedIn: boolean = false;
  registeringForEvent: boolean = false;
  staff: boolean;
  isForApp: boolean;
  libraryCardInputTracker: number = 0;
  unregisterBackButtonAction: any;
  requiredFields: { firstName: boolean, lastName: boolean, email: boolean, phone?: boolean } = { firstName: true, lastName: true, email: true, phone: true }
  errorMessageObj: { noLibraryInfo: boolean, invalidCard: boolean } = { noLibraryInfo: false, invalidCard: false };
  eventRegister: { firstName: string, lastName: string, email: string, phone?: string, card?: string, pin?: string, guests: Array<any>, age: string, eventId: string, customQuestions: any, type: string, id: number, regType: number, attendanceType: string } = { firstName: "", lastName: "", email: "", phone: "", card: "", pin: "", guests: [], age: '', eventId: '', customQuestions: [], type: '', id: null, regType: null, attendanceType: "INPERSON" };
  @ViewChildren(CoEventRegisterCustomQuestionComponent) customQuestionComponent: QueryList<CoEventRegisterCustomQuestionComponent>;
  @ViewChild('cardInput') cardInput;
  @ViewChild('patronPinInput') pinInput;
  constructor(public navCtrl: NavController, private platform: Platform, public navParams: NavParams, public viewCtrl: ViewController, public config: ConfigProvider, public modalCtrl: ModalController, private clientDetails: ClientDetailsProvider, public toast: ToastAlertsProvider, private patronProvider: PatronProvider, public popoverCtrl: PopoverController, public eventsProvider: EventsProvider, public alerter: AlertController, private events:Events, private state: AppState, private loading: LoadingController, private timeout : TimeoutFunctionsProvider, private loginProvider: LoginProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.isForApp = this.state.cordovaAvailable;
    this.viewType = this.state.mode;
    this.staff = this.state.staff;
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.phoneRegex = new RegExp('^[^a-zA-Z]*$');
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.allowGuests = response.settings.events_patron_guests_enabled;
      self.showAges = response.settings.events_age_enabled;
      self.requireLogin = state.staff ? false:response.settings.events_login_required_enabled;
      self.clientSettings = response.settings;
      let lintWindow: any = window; //lint was breaking shit
      if(lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
        lintWindow.cordova.plugins.Keyboard.disableScroll(false);
      }
    });
    eventsProvider.getEventAgesTypes().then((res) => {
      this.eventAges = res.ages.map(age => age.name);
    });
    if (this.state.loggedInPatronId && this.state.patron) {
      this.loggedIn = true;
      this.fillInPatronInfo();
    } else {
      this.loggedIn = false;
    }
    this.events.subscribe('patronLoggedIn', (login) => {
      this.loggedIn = login;
      this.fillInPatronInfo();
    });
    this.getEventSettings();
    this.event = this.navParams.data.event;
    if((this.event.eventType === 'HYBRID' && this.event.inPersonSeatsLeft <= 0) || this.event.eventType === 'ONLINE') {
      this.eventRegister.attendanceType = 'ONLINE';
    }
    if (this.navParams.data.joinWaitlist) {
      this.headerTitle = "Join Waitlist";
    }
    // this.renderCustomQuestions();
    window.addEventListener('native.keyboardhide', this.scrollWindow);
  }

  scrollWindow() {
    window.scroll(0,0);
  }

  ngOnDestroy() {
    let lintWindow: any = window; //lint was breaking shit
    if(lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(true);
    }
    window.removeEventListener('native.keyboardhide', this.scrollWindow);
  }

  hideModal() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  getDetailsEnterPress(required){
    if (this.clientSettings.client_pinless_auth){
      // console.log('oh boy',this.clientSettings)
      this.getDetails(required);
    } else {
      if ((this.eventRegister.card.length <= 0 && this.eventRegister.pin.length <= 0)||(this.eventRegister.card.length <= 0 && this.eventRegister.pin.length > 0)){
        // console.log('its me')
        this.cardInput.setFocus();
      } else if (this.eventRegister.card.length > 0 && this.eventRegister.pin.length <= 0){
        this.pinInput.setFocus();
      } else if (this.eventRegister.card.length > 0 && this.eventRegister.pin.length > 0){
        this.getDetails(required);
      }
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  ionViewDidLoad() {
    setTimeout(() => {
      if (!this.state.patron || this.state.patron === null) {
        if (this.cardInput){
          // console.log('im the main one', this.state.patron);
          this.cardInput.setFocus();
        }
      }
    }, 1000);
  }
  ionViewWillEnter() {
    this.state.homeScanActive = false;
  }
  ionViewDidEnter() {
    this.unregisterBackButtonAction = this.platform.registerBackButtonAction( () => {
      this.hideModal();
    }, 20);
  }
  ionViewWillLeave(){
    this.state.homeScanActive = true;
    this.events.publish('closeKeyboard');
    this.unregisterBackButtonAction();
  }
  getEventSettings(){
      this.searchTags = this.state.eventColors.types;
  }

  fillInPatronInfo(){
    if (!this.state.patron) return;
    this.eventRegister.firstName = this.state.patron.firstName;
    this.eventRegister.lastName = this.state.patron.lastName;
    this.eventRegister.email = this.state.patron.email || "";
    this.eventRegister.phone = this.state.patron.phone || "";
    this.eventRegister.card = this.state.patron.barcode || "";
    this.eventRegister.pin = this.state.patron.pin || "";
  }

  getEventImage(eventType) {
    try {
      let eventTypeObject = this.searchTags.find(object => object.name === eventType);
      return eventTypeObject.image;
    } catch (ex) {
      return "";
    }
  };

  triggerToast(msg,type?) {
    this.toast.showAlert('',msg,type, 5000)
  }

  registerForEvent() {
    this.registeringForEvent = true;
    this.checkForRequiredFields().then(res => {
      if (res) {
        //passes all fields required are filled check
        this.validateForms().then(res => {
          if (res) {
            //passes validation of email and phone fields
            if (this.event.maxAttendees > this.event.totalRegistrants) {
              //If event attendees isn't maxed out already
              this.eventRegister.guests = this.guestList;
              this.eventRegister.eventId = this.event.eventId;
              this.eventRegister.type = 'new';
              this.eventRegister.regType = 1;
              this.eventRegister.id = 0;
              delete this.eventRegister.pin;
              // console.log(JSON.stringify(this.eventRegister))
              this.eventsProvider.registerForEvent(this.eventRegister, this.state.productType).then(res => {
                if (res.ok) {
                  //successful registration
                  this.registeringForEvent = false;
                  this.handleSuccessResponse(res);
                  this.events.publish('registeredEvent', this.event);
                } else if(res.message) {
                  this.registeringForEvent = false;
                  this.triggerToast(res.message);
                } else {
                  this.triggerToast('Sorry, there was an error please refresh and try again', 'warning')
                };
              });
            } else if (this.event.allowWaitlist) {
              //Full event, allowing waitlist
              this.registerForWaitList()
              this.events.publish('registeredEvent', this.event);
            } else {
              //Full event, no waitlist
              this.triggerToast('Sorry, the event is full', 'warning')
            }
          } else {
            //does not pass validation check
            this.triggerToast('Some information is invalid', 'warning');
          }
        });
      } else {
        //does not pass filled required inputs check
        this.triggerToast('Please enter required info', 'warning');
      }
    });
  }

  showAlertForWaitlist(message) {
    let alert = this.alerter.create({
      title: '',
      subTitle: message,
      buttons: [{
        text: 'No',
        handler: data => {
          // console.log('Cancel clicked');
        }
      },
      {
        text: 'Yes',
        handler: data => {
          this.registerForWaitList();
        }
      }]
    });

    alert.present();
  }

  handleSuccessResponse(res) {
    this.triggerToast(res.message, 'success');
    this.hideModal();
  }

  registerForWaitList() {
    this.eventRegister.guests = this.guestList;
    this.eventRegister.eventId = this.event.eventId;
    this.eventRegister.type = 'new';
    this.eventRegister.regType = 2;
    this.eventRegister.id = 0;
    delete this.eventRegister.pin;
    // console.log(this.eventRegister)

    this.eventsProvider.registerForEvent(this.eventRegister, this.state.productType).then(res => {
      if (res && res.ok) {
        this.handleSuccessResponse(res);
      } else if(res && res.message) {
        this.triggerToast(res.message)
      } else {
        this.triggerToast('Sorry, there was an error please try again', 'warning')
      };
    })
  }

  async checkForRequiredFields() {

    let outputArray = [];
    for (var key in this.requiredFields) {
      this.requiredFields[key] = true;
    }

    for (var eventKey in this.eventRegister) {
      if ((eventKey === 'firstName' || eventKey === 'lastName' || eventKey === 'email') && this.eventRegister[eventKey].length <= 0) {
        this.requiredFields[eventKey] = false;
        outputArray.push('false')
      }
    }

    if (this.eventRegister.customQuestions.length > 0) {
      this.eventRegister.customQuestions.forEach((ques, index) => {
        ques.helpText = null;
        ques.link = null;
        ques.regex = null;
        ques.validate = null;
        if (ques.required === true) {
          if (ques.answer === "" || (ques.type === 'checkbox' && ques.answer === 'false')) {
            this.customQuestionComponent.toArray()[index].requiredNotAnswered(true);
            outputArray.push('false')
          } else {
            this.customQuestionComponent.toArray()[index].requiredNotAnswered(false);
          }
        }
      });
    }

    return outputArray.length <= 0;
  }

  async validateForms() {
    let output = [];
    this.requiredFields.email = true;
    this.requiredFields.phone = true;
    for (var key in this.eventRegister) {
      switch (key) {
        case ('email'):
          if (!this.emailRegex.test(this.eventRegister.email)) {
            output.push('email')
          }
          break;
        case ('phone'):
          if (!this.phoneRegex.test(this.eventRegister.phone) || this.eventRegister.phone.length < 7 && this.eventRegister.phone.length != 0) {
            output.push('phone')
          }
          break;
      }
    };

    // this.event.customQuestions.forEach((ques, i) => {
    //   if (ques.validation && ques.validation === 'custom') {
    //     if (!ques.answer.test(ques.regex)) {
    //       output.push(i)
    //     }
    //   }
    // });

    output.forEach(input => {
      this.requiredFields[input] = false;
    });

    return output.length <= 0;
  }

  getDetails(param) {
    if (this.eventRegister.card && (this.eventRegister.pin || this.state.pinless)) {
      let loader = this.loading.create({content:'Retrieving data'});
      loader.present();
      this.errorMessageObj.noLibraryInfo = false;
      this.errorMessageObj.invalidCard = false;
      this.patronProvider.getSummaryDetails(this.eventRegister.card, this.eventRegister.pin).then((res) => {
        loader.dismiss().catch(err=>{});
        if (res.id !== null) {
          // this.eventRegister.firstName = res.name.split(', ')[0];
          // this.eventRegister.lastName = res.name.split(', ')[1];
          this.eventRegister.firstName = res.firstName
          this.eventRegister.lastName = res.lastName
          this.eventRegister.email = res.email;
          this.loginProvider.login(res.barcode, this.eventRegister.pin);
          //this is check if login is turned off from config just to prevent modal
          if (this.state.currentScreen && this.state.currentScreen.settings && this.state.currentScreen.settings.preventPatronLogin ){

          } else {
            this.triggerToast('You are now logged in', 'success');
            if (param) {
              this.loggedIn = true;
              // this.requireLogin = false;
            }
          }
        } else {
          this.errorMessageObj.invalidCard = true;
        }
      }).catch(err => {
        loader.dismiss().catch(err=>{});
        this.triggerToast('Invalid information please try again', 'warning');
      });
    } else {
      this.errorMessageObj.invalidCard = false;
      this.errorMessageObj.noLibraryInfo = true;
    }
  }

  addGuest() {
    this.openGuestPopover();
  }

  openGuestPopover() {
    if (this.event.maxAttendees > (this.event.totalRegistrants + 1 + this.guestList.length)) {
      let customClass = 'custom-guest-popover';
      let popover = this.popoverCtrl.create(CoGuestRegisterInputComponent, { ages: this.eventAges, settings: this.clientSettings }, { cssClass: customClass });
      popover.present({
        ev: ''
      });

      popover.onDidDismiss(data => {
        if (data && data.info) {
          this.guestList.push(data.info);
        }
      });
    } else {
      this.triggerToast('Sorry, there is not enough room for more guests!', 'warning');
    }
  }

  chooseAgeGroup(event) {
    this.eventRegister.age = event.target.value;
  }

  removeGuest(event, index) {
    this.guestList.splice(index, 1);
  }

  logCustomQuestionAnswer(event, index) {
    this.eventRegister.customQuestions[index] = event;
  }

  scanCard() {
    this.loginProvider.requireLogin((res) => {
      // console.log(res);
    }).catch(err=>{console.log(err)});
  }

  logout($event){
    this.viewCtrl.dismiss().then(()=>{
      this.loginProvider.logout();
    }).catch((err) => this.loginProvider.logout());
  }
  myAccountClicked($event){
    this.viewCtrl.dismiss().then(() => {
      this.state.nav.push(CoSelfcheckAccountPage);
    }).catch((err) => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-events-register-modal/co-events-register-modal.ts